import { SxProps } from '@mui/material';
import { theme } from '@src/theme';

export enum IconBaseColor {
  DarkGrey = 'darkGrey',
  LightGrey = 'lightGrey',
  Primary = 'primary',
  Secondary = 'secondary',
}

type IconState = 'default' | 'hover' | 'active' | 'disabled';

type IconStateMap = Record<IconState, string>;

type ColorType = 'fill' | 'stroke';

export const iconStateColorsMap: Record<IconBaseColor, IconStateMap> = {
  [IconBaseColor.DarkGrey]: {
    default: theme.palette.grey['700'],
    hover: theme.palette.grey['600'],
    active: theme.palette.grey['800'],
    disabled: theme.palette.grey['300'],
  },
  [IconBaseColor.LightGrey]: {
    default: theme.palette.grey['300'],
    hover: theme.palette.grey['400'],
    active: theme.palette.grey['500'],
    disabled: theme.palette.grey['300'],
  },
  [IconBaseColor.Primary]: {
    default: theme.palette.primary.main,
    hover: theme.palette.primary.light,
    active: theme.palette.primary.dark,
    disabled: theme.palette.grey['300'],
  },
  [IconBaseColor.Secondary]: {
    default: theme.palette.secondary.main,
    hover: theme.palette.blue.light,
    active: theme.palette.secondary.main,
    disabled: theme.palette.grey['300'],
  },
};

export const getIconStyles = (baseColor: IconBaseColor, colorType: ColorType = 'fill'): SxProps => {
  const colors = iconStateColorsMap[baseColor];

  return {
    '& path': { [colorType]: `${colors.default} !important` },
    '&:hover path': { [colorType]: `${colors.hover} !important` },
    '&:active path': { [colorType]: `${colors.active} !important` },
    '&.Mui-disabled path': { [colorType]: `${colors.disabled} !important` },
  };
};
